// extracted by mini-css-extract-plugin
export var caption = "ScientistOfTheDayListing-module--caption--8ca31";
export var container = "ScientistOfTheDayListing-module--container--a243f";
export var content = "ScientistOfTheDayListing-module--content--a0fab";
export var contentCategory = "ScientistOfTheDayListing-module--contentCategory--6c336";
export var date = "ScientistOfTheDayListing-module--date--90ffa";
export var featuredScientist = "ScientistOfTheDayListing-module--featuredScientist--64936";
export var image = "ScientistOfTheDayListing-module--image--d3123";
export var loadMoreButton = "ScientistOfTheDayListing-module--loadMoreButton--b7a79";
export var scientistofthedaylisting = "ScientistOfTheDayListing-module--scientistofthedaylisting--d1043";
export var scientistsTiles = "ScientistOfTheDayListing-module--scientistsTiles--09dc7";
export var text = "ScientistOfTheDayListing-module--text--e6cf0";